import styled from 'styled-components'

export const StyledNewsSavedSearchViewAll = styled.div``
